/**
 * Живые события заказов: WebSocket `/admin/ws` (BR-20). Сервер только пишет;
 * по контракту на любое событие перечитываем счётчик колокольчика. Связь
 * рвётся — переподключаемся с паузой 1 → 2 → 4 … 30 с и каждый раз с текущим
 * токеном доступа: клиент API мог его уже обновить.
 */
import { LIVE_FIRST_DELAY, nextLiveDelay } from './model'

export interface LiveOptions {
  /** Адрес с токеном. */
  url: (token: string) => string
  /** Текущий токен доступа; null — входа нет, ждём и пробуем снова. */
  token: () => string | null
  /** Пришло событие — какое, не важно: перечитываем уведомления. */
  onMessage: () => void
}

/** Открыть связь. Возвращает закрытие — без переподключений. */
export function connectLive({ url, token, onMessage }: LiveOptions): () => void {
  let socket: WebSocket | null = null
  let timer = 0
  let delay = LIVE_FIRST_DELAY

  function retry() {
    timer = window.setTimeout(open, delay)
    delay = nextLiveDelay(delay)
  }

  function open() {
    const current = token()
    if (!current) {
      retry()
      return
    }
    const ws = new WebSocket(url(current))
    socket = ws
    ws.onopen = () => {
      delay = LIVE_FIRST_DELAY
    }
    ws.onmessage = () => {
      onMessage()
    }
    // После ошибки браузер всегда закрывает связь — переподключаемся здесь.
    ws.onclose = () => {
      if (socket !== ws) return
      socket = null
      retry()
    }
  }

  open()

  // Закрытие снимает паузу, а свою связь забывает до close(): её onclose
  // тогда ничего не делает, и переподключаться некому.
  return () => {
    window.clearTimeout(timer)
    const ws = socket
    socket = null
    ws?.close()
  }
}
